// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2FU6m","amount":"Amount_amount__1H_ph","tip":"Amount_tip__tWw4M","tipHeader":"Amount_tipHeader__P7RT0","tipsWrap":"Amount_tipsWrap__AuBmI"};